import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import LoadingButton from "@mui/lab/LoadingButton";
import { styles } from "../utils/styles";

const ConfirmDialog = ({ open, onClose, onSubmit, title, children, loading = false, maxWidth }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} >
      <DialogTitle>{title}</DialogTitle>
      {children && <DialogContent dividers>{children}</DialogContent>}
      <DialogActions>
        <LoadingButton variant="outlined" onClick={onClose} disabled={loading}>
          Cancel
        </LoadingButton>
        <LoadingButton
          variant="contained"
          color="error"
          onClick={onSubmit}
          loading={loading}
          sx={{ ...styles.customButton }}
        >
          Submit
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
